// extracted by mini-css-extract-plugin
export default {"socialLinks":"socialLinks_socialLinks__O63od"};